//on styleselect div click
  $('[data-widget-container] .styledSelect').on('click', function (e) {
    e.stopPropagation();
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $(this).next('ul.options').hide();
    }else {
      $(this).addClass('active');
      $(this).next('ul.options').show();
    }
  });

  //on ul > li click
  $('[data-widget-container] .select').find('.options li').on('click',function (e) {
    e.stopPropagation();
    var sellingPlanId = $(this).attr('value');
    $(this).closest('.quick-reacharge-subscription').find('input[name="selling_plan"]').attr('value',sellingPlanId);
    $(this).closest('.quick-reacharge-subscription').find('[data-widget-container]').find('.styledSelect').attr('data-selling-id',sellingPlanId);
    $(this).closest('[data-widget-container]').find('.styledSelect').text($(this).text()).removeClass('active');
    $(this).parent().hide();
    $(this).prependTo($(this).parent());
  });

  //on recharge option change
  $(document).on('change','[data-widget-container] input[name="selling_plan_select"]',function(e){
    console.log('clcicici');
    e.stopPropagation();
    if($(this).val() == 'onetime'){
      $(this).closest('.quick-reacharge-subscription').find('input[name="selling_plan"]').attr('value','');
      $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-subsave]').find('input[name="selling_plan_select"]').prop('checked',false);
      $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-subsave]').removeClass('rc-option--active');
      let ontimePriceTxt = $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-onetime]').find('[data-price-onetime]').text();
      $('.product__info-container .price .price__regular .price-item--regular').text(ontimePriceTxt);
    }else{
      var selectedSellingPlanId = $(this).closest('.quick-reacharge-subscription').find('[data-widget-container]').find('.styledSelect').attr('data-selling-id');
      $(this).closest('.quick-reacharge-subscription').find('input[name="selling_plan"]').attr('value',selectedSellingPlanId);
      $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-onetime]').find('input[name="selling_plan_select"]').prop('checked',false);
      $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-onetime]').removeClass('rc-option--active');
      let subPriceTxt = $(this).closest('[data-template-legacy-radio]').find('.rc-legacy-radio[data-option-subsave]').find('[data-price-subsave]').text();
      $('.product__info-container .price .price__regular .price-item--regular').text(subPriceTxt);
    }
    $(this).closest('.rc-legacy-radio').addClass('rc-option--active');
    $(this).prop('checked',true);
  });
// $(document).ready(function(){
// 		  $(document).on('change','[data-widget-container] input[name="selling_plan_select"]',function(e){
// 		  var optionSelected = $(".rc-template__legacy-radio .rc_widget__option__input:checked", this ).attr("data-price");
//           var valueSelected = this.value;
// 		  alert("Hello! I am an alert box!!");
          
// 		  $(this).closest('.product-single__meta').find(".money").html(optionSelected);
//             alert("Hello!");
// 		});
// 		});

let userDisabledToggle = true;

let previousCartQuantity = 0;

// Fetch initial cart quantity
fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        previousCartQuantity = cart.item_count;
    });

function upCartTrigger() {
    const cartDrawerDiv = document.getElementById('upCart');
    if (!cartDrawerDiv) return;

    const shadowElement = cartDrawerDiv.shadowRoot;
    const insideCart = shadowElement.querySelector('#UpcartPopup');
    const privacyToggle = insideCart?.querySelector('.styles_ToggleSwitch__');

    if (privacyToggle && userDisabledToggle) {
        const activeToggle = privacyToggle.classList.contains('styles_ToggleSwitch--active__');
        if (!activeToggle) {
            privacyToggle.click();
        }
    }
}

// Observe cart changes
observeCartChanges();

function observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
            const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
            const isCartChangeRequest = /\/cart\//.test(entry.name);

            if (isValidRequestType && isCartChangeRequest) {
                // Fetch the updated cart
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        if (cart.item_count !== previousCartQuantity) { 
                            console.log('Cart quantity changed:', cart.item_count);
                            previousCartQuantity = cart.item_count; // Update previous quantity
                            
                            setTimeout(() => {
                                upCartTrigger();
                            }, 1000);
                        }
                    });
            }
        });
    });

    cartObserver.observe({ entryTypes: ["resource"] });
}

function togglePopup() { 
    $(".content").toggle(); 
}


// play and pause video on click jquery for landing page
$(document).ready(function(){
  $('.section-video-with-text .play-btn').click(function(){
    var parentElement = $(this).parent();
    var video = parentElement.find('video');
    var iframe = parentElement.find('iframe');
    if(video.length > 0){
      if (video.get(0).paused) {
        video.get(0).play();
        $(this).children('.button-play').hide();
        video.addClass('video-playing');
      } else {
        video.get(0).pause();
        $(this).children('.button-play').show();
        video.removeClass('video-playing').addClass('video-paused');
      }
    }

    if (iframe.length > 0) {
      var iframeSrc = iframe.attr('data-src');
      iframe.attr('src', iframeSrc + '&autoplay=1' );
      parentElement.addClass('iframe-playing');
    }

  });
});


  document.addEventListener('DOMContentLoaded', function () {
    const openNavBtn = document.querySelector('.js-drawer-open-nav');
    const closeNavBtn = document.querySelector('.js-drawer-close');
    const navDrawer = document.getElementById('NavDrawer');

    // Open the drawer
    if (openNavBtn && navDrawer) {
      openNavBtn.addEventListener('click', function () {
        navDrawer.classList.add('drawer--is-open');
        document.documentElement.classList.add('js-drawer-open'); // <html>
        document.body.classList.add('js-drawer-open');           // <body>
        console.log('Drawer opened');
      });
    }

    // Close the drawer
    if (closeNavBtn && navDrawer) {
      closeNavBtn.addEventListener('click', function () {
        navDrawer.classList.remove('drawer--is-open');
        document.documentElement.classList.remove('js-drawer-open'); // <html>
        document.body.classList.remove('js-drawer-open');           // <body>
        console.log('Drawer closed');
      });
    }
  });






// Zipify OCU integration
// ((o,c,u)=>{o[c]=o[c]||{},o[u]=o[u]||{},o[c].OCU=o[c].OCU||{api:o[u]}})(window,'Zipify','OCUApi');Zipify.OCU.api.customAddToCartEventHandler=t=>{try{let a=OCUApi.context.popupDispatcher.event;if(a.preventDefault(),a.stopPropagation(),a.stopImmediatePropagation(),Zipify.OCU.api._sub)return;Zipify.OCU.api._sub=!0,t.disabled=!1,OCUApi.context.popupDispatcher.event.target.click(),setTimeout(()=>Zipify.OCU.api._sub=!1,50)}catch(e){console.log(e.message),t?.click()}};

// js for descp open
document.addEventListener('DOMContentLoaded', function () {
  const startTime = Date.now();
  const interval = setInterval(() => {
    document.querySelectorAll('.cs-prd-des').forEach(function (el) {
      const siblingH5 = el.parentElement.querySelector('h5.show');
      if (siblingH5) {
        el.style.display = 'block';
      } else {
        el.style.display = 'none';
      }
    });

    // Stop observing after 6 seconds
    if (Date.now() - startTime >= 6000) {
      clearInterval(interval);
    }
  }, 250); // checks every 250ms
});

// js for upsell
 // document.addEventListener('DOMContentLoaded', function () {
 //    document.body.addEventListener('click', function (e) {
 //      // Track AddToCart via upsell button
 //      const upsellAddBtn = e.target.closest('.ocu-proceed');
 //      if (upsellAddBtn) {
 //        console.log('Upsell AddToCart triggered');

 //        if (typeof fbq === 'function') {
 //          fbq('track', 'AddToCart');
 //          console.log('FB Pixel: AddToCart sent');
 //        }

 //        if (typeof twq === 'function') {
 //          twq('track', 'AddToCart');
 //          console.log('Twitter Pixel: AddToCart sent');
 //        }
 //      }

 //      // Track InitiateCheckout via upsell checkout button
 //      const checkoutBtn = e.target.closest('.ocu-checkout-button');
 //      if (checkoutBtn) {
 //        console.log('Upsell Checkout triggered');

 //        if (typeof fbq === 'function') {
 //          fbq('track', 'InitiateCheckout');
 //          console.log('FB Pixel: InitiateCheckout sent');
 //        }

 //        if (typeof twq === 'function') {
 //          twq('track', 'InitiateCheckout');
 //          console.log('Twitter Pixel: InitiateCheckout sent');
 //        }
 //      }
 //    });
 //  });

  // document.addEventListener('DOMContentLoaded', function () {
  //   document.body.addEventListener('click', function (e) {
  //     // Accept button: adds multiple upsell products
  //     const acceptBtn = e.target.closest('.ocu-proceed');
  //     if (acceptBtn) {
  //       console.log('Zipify OCU: Offer accepted, tracking AddToCart');

  //       if (typeof fbq === 'function') {
  //         fbq('track', 'AddToCart');
  //       }

  //       if (typeof twq === 'function') {
  //         twq('track', 'AddToCart');
  //       }
  //     }

  //     // Decline button: adds only original product
  //     const declineBtn = e.target.closest('.ocu-decline');
  //     if (declineBtn) {
  //       console.log('Zipify OCU: Offer declined');

  //       // Optional: track AddToCart for single product
  //       if (typeof fbq === 'function') {
  //         fbq('track', 'AddToCart');
  //       }

  //       if (typeof twq === 'function') {
  //         twq('track', 'AddToCart');
  //       }
  //     }
  //   });
  // });